import React from 'react';
import {useRef} from 'react';

import {motion} from 'framer-motion';
import {useInView} from 'framer-motion';
import {useIntl} from 'react-intl';

export const VideoSection2: React.FC<React.PropsWithChildren<unknown>> = () => {
  const intl = useIntl();
  const ref = useRef(null);
  const isInView = useInView(ref, {once: true, amount: 0.3});

  return (
    <section ref={ref} className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <motion.div
          className="text-center mb-16"
          // initial={{opacity: 0, y: 50}}
          // animate={isInView ? {opacity: 1, y: 0} : {}}
          // transition={{duration: 0.8, ease: 'easeOut'}}
        >
          <h2 className="text-4xl md:text-6xl font-light text-black mb-6">
            {intl.formatMessage({id: 'home.videoSection2.title'})}
          </h2>
          <p className="text-xl md:text-2xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            {intl.formatMessage({id: 'home.videoSection2.description'})}
          </p>
        </motion.div>

        {/* Video with rounded corners and shadow */}
        <motion.div
          className="relative rounded-3xl overflow-hidden shadow-2xl"
          // initial={{opacity: 0, scale: 0.95}}
          // animate={isInView ? {opacity: 1, scale: 1} : {}}
          // transition={{duration: 1, delay: 0.3}}
        >
          <video
            autoPlay
            loop
            muted
            playsInline
            className="w-full h-96 md:h-[500px] object-cover"
          >
            <source src="/images/stryd5/charging.mp4" type="video/mp4" />
          </video>

          {/* Subtle overlay for depth */}
          <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent" />
        </motion.div>

        {/* Feature highlights below video */}
        <motion.div
          className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8"
          // initial={{opacity: 0, y: 30}}
          // animate={isInView ? {opacity: 1, y: 0} : {}}
          // transition={{duration: 0.8, delay: 0.6}}
        >
          <div className="text-center">
            <h3 className="text-xl font-semibold text-black mb-2">
              {intl.formatMessage({id: 'home.videoSection2.feature1Title'})}
            </h3>
            <p className="text-gray-600">
              {intl.formatMessage({
                id: 'home.videoSection2.feature1Description',
              })}
            </p>
          </div>

          <div className="text-center">
            <h3 className="text-xl font-semibold text-black mb-2">
              {intl.formatMessage({id: 'home.videoSection2.feature2Title'})}
            </h3>
            <p className="text-gray-600">
              {intl.formatMessage({
                id: 'home.videoSection2.feature2Description',
              })}
            </p>
          </div>

          <div className="text-center">
            <h3 className="text-xl font-semibold text-black mb-2">
              {intl.formatMessage({id: 'home.videoSection2.feature3Title'})}
            </h3>
            <p className="text-gray-600">
              {intl.formatMessage({
                id: 'home.videoSection2.feature3Description',
              })}
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
